import React from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from 'components/layout/forms/Checkbox';
import translations from 'services/translations/translations';

import IInstallation from '../../IInstallation';

const InstallationDetails = ({
  collapsed,
  locked,
  installation,
  setInstallation,
}: {
  collapsed: boolean;
  locked: boolean;
  installation: IInstallation;
  setInstallation: (installation: IInstallation) => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common, translations.offers]);

  if (!collapsed) {
    return null;
  }

  const handleIsCustomInstallationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInstallation({
      ...installation,
      installation: null,
      isCustomInstallation: event.target.checked,
      sellingPrice: '',
      sellingPriceUnit: '',
    });
  };

  const offerIsLocked = () => locked;

  return (
    <div className="item-details-box">
      <Checkbox
        checked={installation.isCustomInstallation}
        className="item-details-checkbox"
        disabled={offerIsLocked()}
        label={t(`${translations.calculationWindow}:Custom installation`)}
        onChange={handleIsCustomInstallationChange}
      />
    </div>
  );
};

export default InstallationDetails;
